/*
 * pogi-lineup — material toggle for Shop All lineup rows (§20 row 4).
 * Only the bags row ships a toggle (Recycled / Compostable). Each toggle
 * button carries the material's copy as data-* attributes; clicking it swaps
 * the row's for-what / sub / blurb / spec chips / price / Shop href in place.
 * Image stays the same across materials (matches the prototype).
 */
class PogiLineup extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-lrow-mat]');
      if (!btn) return;
      const row = btn.closest('[data-lrow]');
      if (!row) return;

      row.querySelectorAll('[data-lrow-mat]').forEach((b) => {
        const on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', String(on));
      });

      const set = (sel, val) => {
        const el = row.querySelector(sel);
        if (el && val != null) el.textContent = val;
      };
      set('[data-lrow-forwhat]', btn.dataset.forwhat);
      set('[data-lrow-blurb]', btn.dataset.blurb);
      set('[data-lrow-price]', btn.dataset.price);

      const subEl = row.querySelector('[data-lrow-sub]');
      if (subEl) {
        subEl.textContent = btn.dataset.sub || '';
        subEl.style.display = btn.dataset.sub ? '' : 'none';
      }

      const cta = row.querySelector('[data-lrow-cta]');
      if (cta && btn.dataset.href) cta.setAttribute('href', btn.dataset.href);

      const chips = row.querySelector('[data-lrow-specs]');
      if (chips && btn.dataset.specs != null) {
        chips.textContent = '';
        btn.dataset.specs.split('|').forEach((s) => {
          const txt = s.trim();
          if (!txt) return;
          const span = document.createElement('span');
          span.className = 'pogi-lrow__chip';
          span.textContent = txt;
          chips.appendChild(span);
        });
      }
    });
  }
}

if (!customElements.get('pogi-lineup')) {
  customElements.define('pogi-lineup', PogiLineup);
}
